//REACT
import React from 'react'
import Carousel from "react-slick";

//Imagenes
import dg2 from "assets/img/dg2.jpg";
import dg3 from "assets/img/BANNER_FES.jpg";

//Secciones
import ItemCarrusel from "./ItemCarrusel.js"
import Button from "components/CustomButtons/Button.js";

const settings = {
  dots: true,
  infinite: true,
  speed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed:15000
};

export default function Carrusel() {
  return (
    <div>
      <Carousel {...settings}>
        <ItemCarrusel
            tieneBtn={false}
            imagen={dg3}
            titulo="Certificado Digital SII. (Firma Simple)"
            descripcion="Acreditado por el Servicio de Impuestos Internos"       
            link="/compra/firma-simple"
            txtBoton01="COMPRAR AHORA"                 
        />
        <ItemCarrusel
            tieneBtn={true}
            imagen={dg2}
            titulo="FIRMA AVANZADA"
            descripcion="Incluye dispositivo que puedes portar para firmar tus documentos"
            link="/compra/firma-token"
            txtBoton02="COMPRAR AHORA"   
        />
        {/*<ItemCarrusel
            imagen={dg1}
            titulo="FIRMA AVANZADA ONLINE"
            descripcion="Firma de manera online tus documentos legales (Notariales)"
            link="/compra/firma-online"
        />*/}
      </Carousel>
    </div>
  )
}
